import React from 'react';
//@ts-ignore
import { tw } from '@careinfo/tailwind';
import Card from '../../Reusable/Card';

const GraphCardContent = () => {
  return (
    <>
      <Card>
        <div
          className={tw`bg-white rounded-lg shadow-sm p-4 w-full h-64 relative`}
        >
          {/* Horizontal center line */}
          <div
            className={tw`absolute left-0 right-0 top-1/2 h-px bg-gray-300`}
          />
          <div className={tw`relative z-10 text-2xl font-bold`}>Graph</div>
        </div>
      </Card>
    </>
  );
};

export default GraphCardContent;
